import styled from 'styled-components';

export const StepRoleSC = styled.div`
  grid-area: form;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .tiles {
    margin-top: 30px;
    display: grid;
    grid-template-columns: minmax(160px, 220px) minmax(160px, 220px);
    grid-template-rows: repeat(3, 120px);
    grid-column-gap: 16px;
    grid-row-gap: 20px;
  }

  @media (min-width: 900px) {
    .tiles {
      margin-top: 0px;
    }

    &&&& {
      grid-row-start: 2;
      align-self: flex-start;
    }
  }
  .btn {
    margin-top: 60px;
  }
`;

interface ITileProps {
  selected: boolean;
}

export const Tile = styled.div<ITileProps>`
  border-radius: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  user-select: none;
  transform: ${({ selected }) => (selected ? 'scale(0.98)' : 'scale(1)')};
  background: ${({ selected }) => (selected ? '#333d6c' : '#fff')};
  cursor: pointer;
  border: 1px solid transparent;

  span {
    font-size: 12px;
    color: ${({ selected }) => (selected ? '#fff' : '#333d6c')};
  }

  svg {
    margin-bottom: 8px;

    path {
      fill: ${({ selected }) => (selected ? '#fff' : '#333d6c')};
    }
  }

  &:hover {
    border: ${({ selected }) => (selected ? '1px solid transparent;' : '1px solid #333d6c')};
  }
`;

export const HighlightedTile = styled(Tile)`
  background: ${({ selected }) => (selected ? '#6ad5e5' : '#fff')};

  svg {
    path {
      fill: ${({ selected }) => (selected ? '#fff' : '#6ad5e5')};
    }
  }

  span {
    color: ${({ selected }) => (selected ? '#fff' : '#6ad5e5')};
  }

  &:hover {
    border: 1px solid transparent;
    background: ${({ selected }) => (selected ? '#6ad5e5' : '#e1f7fa')};
  }
`;
